import { useState } from 'react';
import planQuery from 'API/handlers/planQuery';
import CoverageStatus from './plans.enum';

function usePlansAPI() {
  const [statusCoveragePlan, updateStatusCP] = useState('');
  const [isLoading, toggleLoading] = useState(false);
  const [isDataLoaded, toggleDataLoaded] = useState(false);

  return {
    data: {
      status: statusCoveragePlan,
      isDataLoaded,
      isLoading,
    },
    clearPlanState() {
      toggleDataLoaded(false);
      updateStatusCP('');
    },
    fetchCoveragePlan() {
      toggleLoading(true);

      return planQuery
        .fetchCoveragePlan()
        .then((response) => {
          const { status } = response.data;

          if (Object.keys(CoverageStatus).includes(status)) {
            updateStatusCP(status);
          }
        })
        .finally(() => {
          toggleLoading(false);
          toggleDataLoaded(true);
        });
    },
  };
}

export default usePlansAPI;
